import React from "react";
import { Settings, CheckSquare, ArrowRight, Users, Clock, Shield } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { useNavigate } from 'react-router-dom';

const ProductsSection = () => {

    const navigate = useNavigate();

    const products = [
        {
            icon: <Settings className="w-8 h-8" />,
            title: "Gestão",
            description: "Controle e administração de ordens de serviços. Recomendado nos seguimentos de assistência técnica, mecânica, suporte e muito mais.",
            features: ["Controle de OS", "Gestão de Clientes", "Relatórios Detalhados", "Histórico Completo"],
            color: "from-[#0c1248] to-[#0c1248]/80",
            link: "#"
        },
        {
            icon: <CheckSquare className="w-8 h-8" />,
            title: "Checklist",
            description: "Agilidade, mobilidade e organização para seus serviços.",
            features: ["Interface Mobile", "Checklists Personalizados", "Sincronização em Tempo Real", "Relatórios Automáticos"],
            color: "from-[#d03737] to-[#d03737]/80",
            link: "/checklist"
        }
    ];

    return (
        <section id="produtos" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                        Nossos Produtos
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Conheça nossos produtos. Realizamos nossas operações com qualidade e segurança.
                    </p>
                </div>

                {/* Products Grid */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    {products.map((product, index) => (
                        <Card
                            key={index}
                            className="group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-0 shadow-lg overflow-hidden flex flex-col h-full"
                        >
                            <div className={`h-2 bg-gradient-to-r ${product.color}`}></div>
                            <CardHeader className="pb-4">
                                <div className="flex items-center space-x-4 mb-4">
                                    <div className={`p-3 rounded-xl bg-gradient-to-r ${product.color} text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                                        {product.icon}
                                    </div>
                                    <div>
                                        <CardTitle className="text-2xl font-bold text-gray-900">
                                            {product.title}
                                        </CardTitle>
                                    </div>
                                </div>
                                <CardDescription className="text-gray-600 text-base leading-relaxed">
                                    {product.description}
                                </CardDescription>
                            </CardHeader>
                            <CardContent className="pt-0 flex-1 flex flex-col">
                                <div className="space-y-3 mb-6 flex-1">
                                    {product.features.map((feature, featureIndex) => (
                                        <div key={featureIndex} className="flex items-center space-x-3">
                                            <div className={`w-2 h-2 rounded-full bg-gradient-to-r ${product.color}`}></div>
                                            <span className="text-gray-700">{feature}</span>
                                        </div>
                                    ))}
                                </div>
                                <Button
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                        navigate(product.link);
                                    }}
                                    variant="outline"
                                    className={`w-full group border-2 hover:bg-gradient-to-r ${product.color} hover:text-white hover:border-transparent transition-all duration-300 mt-auto`}
                                >
                                    Saiba mais
                                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                                </Button>
                            </CardContent>
                        </Card>
                    ))}
                </div>

                {/* Features */}
                <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="text-center group">
                            <div className="w-16 h-16 bg-gradient-to-r from-[#0c1248] to-[#d03737] rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                                <Users className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Foco no Cliente</h3>
                            <p className="text-gray-600">Soluções pensadas para atender suas necessidades específicas</p>
                        </div>
                        <div className="text-center group">
                            <div className="w-16 h-16 bg-gradient-to-r from-[#d03737] to-[#0c1248] rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                                <Clock className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Otimização do Tempo</h3>
                            <p className="text-gray-600">Automatize processos e ganhe mais tempo para focar no essencial</p>
                        </div>
                        <div className="text-center group">
                            <div className="w-16 h-16 bg-gradient-to-r from-[#0c1248] to-[#d03737] rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                                <Shield className="w-8 h-8 text-white" />
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Máxima Segurança</h3>
                            <p className="text-gray-600">Seus dados protegidos com as melhores práticas de segurança</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductsSection;